import { Plus } from 'lucide-react';

import { ProtectedComponent } from '@/components/ProtectedComponent';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

import { useToggle } from '@/hooks/use-toggle';

import { useFetchAllPermissionsQuery, useFetchAllRolesQuery } from '@/query/role.query';

import { Permissions } from '@/constants';

import { RoleCreate } from '../RoleCreate/RoleCreate';

import { RolePermission } from './components/role';

export const RoleListPage = () => {
  const { data, isLoading } = useFetchAllRolesQuery();
  const { state, toggle } = useToggle();
  const { data: allPerms } = useFetchAllPermissionsQuery();

  const roles = data || [];

  return (
    <>
      <Card className="bg-muted rounded-2xl p-1 pt-0 gap-0 border-0 shadow-none flex flex-col">
        <CardHeader className="flex flex-row items-center justify-between px-5 py-3">
          <CardTitle className="text-sm">Roles & permissions</CardTitle>
          <ProtectedComponent requiredPermissions={[Permissions.RolesCreateUpdate]}>
            <Button variant="outline" size={'sm'} onClick={toggle}>
              <Plus className="h-4 w-4" />
              Add new role
            </Button>
          </ProtectedComponent>
        </CardHeader>
        <CardContent className="p-0 bg-card rounded-xl shadow-sm flex-1">
          {isLoading ? (
            <div className="p-6 space-y-4">
              <Skeleton className="h-6 w-1/3 rounded-md" />
              <Skeleton className="h-6 w-full rounded-md" />
              <Skeleton className="h-6 w-full rounded-md" />
              <Skeleton className="h-6 w-full rounded-md" />
            </div>
          ) : roles.length === 0 ? (
            <div className="p-6 text-sm text-muted-foreground">
              No custom roles defined yet. Add a role to get started.
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="border-b">
                  <tr>
                    <th className="text-left font-medium p-3">Role name</th>
                    <th className="text-left font-medium p-3">Description</th>
                    <th className="text-left font-medium p-3">Permissions</th>
                    <ProtectedComponent
                      requiredPermissions={[Permissions.RolesCreateUpdate, Permissions.RolesDelete]}
                    >
                      <th className="text-left font-medium p-3">Action</th>
                    </ProtectedComponent>
                  </tr>
                </thead>
                <tbody>
                  {roles.map(r => (
                    <RolePermission key={r.id} role={r} permissions={allPerms} />
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </CardContent>
      </Card>

      <RoleCreate isOpen={state} toggle={toggle} />
    </>
  );
};
